export default {
  //search-company
  people: "People",
  clearAll: "Clear All",
  searchProspects: "Search...",
  //actions
  isFoundIn: "Is found in ",
  isNotFoundWithinAnyLists: "is not found within any lists",
  l: " lists",
  remove: "Remove",
  saveToLists: "Save to Lists",
  DeleteFailed: "Delete Failed",
  //delete dialog
  areYouSureYouWantToDeleteThisRecord:
    "Are you sure you want to delete this record?",
  proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
    "Proceeding with deletion will result in permanent removal of the list",
  byCancelingYouEnsureThatNoListsWillBeRemoved:
    "By canceling, you ensure that no lists will be removed",
  //export dialog
  holdOnWereGeneratingYourExport: "Hold on, we're generating your export",
  UseThisButtonOnlyIfYouWishToCancelYourAction:
    "Use this button only if you wish to cancel your action",
  //save search pop
  saveSearch: "Save Search",
  newSaveSearch: "New Save Search",
  UpdateSavedSearch: "Update Saved Search",
  enterNewSearchName: "Enter New Search Name",
  visibility: "Visibility",
  manageWhoCanSeeYourSavedSearch: "Manage who can see your saved search",
  private: "Private",
  onlyYouCanSeeYourSavedSearch: "Only you can see your saved search",
  everyoneCanSeeYourSavedSearch: "Everyone can see your saved search",
  pinSavedSearch: "Pin Saved Search",
  findSavedSearch: "Find saved search",
  enterSavedSearchName: "Enter saved search name",
  duplicate: "Duplicate",
  update: "Update",
  enterATitleForYourCard: "Enter a title for your card",
  enterYourCardNumber: "Enter your card number",
  digit: "3-digit",
  provideYourCompleteAddress: "Provide your complete address",
  selectYourCountry: "Select your country",
  //add credits pop
  ClickTheButtonBelowToAddMoreCredits:
    "Click the button below to add more credits!",
  PleaseEnterTheAmountYouLikeToTopUpToYourCredit:
    "Please enter the amount you'd like to top up to your credit",
  //companyLink\contactBtn\functionBtn\default
  more: "More",
  verified: "Verified",
  GetEmailSuccessfully: "Got Email Successfully",
  CopySuccessfully: "Copied Successfully",
  recorded: "Recorded",
  implement: "Implement",
  sequence: "Sequence",
  of: "of",
  toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
    "To assist you effectively, we require further details about your search preferences. Please utilize the filter options in the left panel to specify your desired criteria, enabling us to refine the search results and provide you with targeted individuals that meet your requirements.",

  //filter
  all: "All",
  my: "My",
  team: "Team",
  lists: "Saved Lists",
  employees: "Employees",
  technologies: "Technologies",
  socialmedia: "Social media",
  enterSocialMedia: "Enter Social media",
  noResultsFound: "No results found",
  searchCompanies: "Search Companies",
  filters: "Filters",
  enterCompanies: "Enter Companies",
  accountHqLocation: "Account HQ Location",
  CityStateCountryZIP: "City/State/Country/ZIP",
  enterLocations: "Enter Locations",
  revenue: "Revenue",
  chooseARangeOfRevenue: "Choose a range of revenue",
  ofRevenueIsUnknown: "of revenue is unknown",
  technology: "Technology",
  category: "Category",
  categories: "Categories",
  enterCategories: "Enter Categories",
  enterTechnologies: "Enter Technologies",
  searchCategories: "Search categories",
  searchTechnologies: "Search technologies",
  enterIndustries: "Enter Industries",
  employee: "Employee",
  predefinedRange: "Predefined Range",
  ofEmployeesIsUnknown: "of employees is unknown",
  enterNames: "Enter Names",
  jobTitle: "Job Title",
  searchForAJobTitle: " Search for a Job Title",
  founded: "Founded",
  chooseARangeOfFoundedTime: "Choose a range of time",
  from: "From",
  to: "To",
  specialties: "Specialities",
  enterSpecialties: "Enter Specialties",
  location: "Location",
  excludedLocationsLabel: "Location [exclude]",
  location_exclude: "[exclude]",
  total: "Total",
  department: "Department",
  EnterDepartments: "Enter Departments",
  JobTitle: "Job Title",
  EnterJobTitles: "Enter Job Titles",
  ManagementLevel: "Management Level",
  EnterManagementLevels: "Enter Management Levels",
  AccountHQ: "Company location",
  ContactHQ: "Person location",
  departmentFunction: "Department Function",
  EnterJobFunctions: "Enter Job Functions",
  enterNamesAndPressTheEnterKey: "Enter names and press the Enter key...",
  EnterJobTitlesAndPressTheEnterLKey: "Enter titles and press the Enter key...",
  filterInclude: "Include",
  filterExclude: "Exclude",
  filterSelectAll: "Select all",
  filterDeselectAll: "Deselect all",
  filterRegionOther: "Other",
  contactDetails: "Contact details",
  filterMustContain: "Must contain",
  filterWorkEmail: "Work email",
  filterPersonalEmail: "Personal email",
  filterPhone: "Phone",
  filterHasEmail: "Has email",
  filterHasPhone: "Has phone",
  filterExcludeWithoutContact: "Exclude contacts without details",
  pleaseSelectRange: "Please select a range",
  exclude_locations: "Exclude Locations",

  //table
  selectAllCompanies: "Select All Companies",
  selected: "Selected",
  export: "Export",
  industry: "Industry",
  keywords: "Keywords",
  companyLocation: "Company Location",
  action: "Action",
  contact: "Contact",
  Title: "Title",
  clearSelection: "Clear Selection",
  selectNumberOfCompanies: "Select number of companies",
  maxCompanies: "Max companies",
  youCanOnlySelectAMaximumOf25Companies:
    "You can only select a maximum of 25 companies.",
  UpgradeYourPlanNow: "Upgrade your plan now!",
  viewPlans: "View Plans",
  applySelection: "Apply Selection",
  selectNumberOfProspects: "Select number of prospects",
  maxProspects: "Max prospects",
  maxProspectsPerCompany: "Max prospects per company",
  youCanOnlySelectAMaximumOf25Prospects:
    "You can only select a maximum of 25 prospects.",
  PleaseSelectTheDataToBeExported: "Please select the data to be exported",
  overview: "Overview",
  genericContacts: "Generic Contacts",
  size: "Size",
  contactLocation: "Contact Location",
  pleaseSelectItems: "please select items",
  specialties: "Specialties",
  moreSpecialty: "+{count} more",

  // 新UI
  prospectsSearch: "Prospects Search",
  companiesSearch: "Companies Search",
  savedSearches: "Saved searches",
  savedLists: "Saved lists",

  // saved list and saved searches
  sortAndFilter: "Sort & Filter",
  sortBy: "Sort by",
  filterAll: "All",
  filterPrivate: "Private",
  filterTeam: "Team",
  searchSavedLists: "Search saved lists",
  savedSearchName: "Saved search name",
  noFilteringOptionsAvailable: "No filtering options available",
  manageWhoCanSeeThisSearch: "Manage who can see this search",
  noSavedSearchesMatchYourQuery:
    "No saved searches match your query. Try using different keywords or check your spelling.",
  onlyU: "Only you",
  anyoneOnTheTeam: "Anyone on the team",
  createNewList: "Create New List",
  groupTeam: "Team",
  groupPersonal: "Personal",
  manageWhoCanViewThisList: "Manage who can view this list",
  enterAListName: "Enter a list name",
  savedList: "Saved List",
  listName: "List name",
  saveContactsTo: "Save contact to",
  contactEmails: "Contact emails",
  contactPhones: "Contact phones",
  unlockContactDetails: "Unlock Contact Details",
  getContactInfo: "Get Contact Info",
  contactDetailsAreOnTheWay: "Contact details are on the way",
  noDataAvailable: "No Data Available",
  accessEmails: "Access emails",
  accessPhoneNumber: "Access phone numbers",
  accessPhoneNumbersAndEmails: "Access phone numbers and emails",

  redemptionComplete: "Redemption Complete!",
  bulkRedeemProcessing: "Bulk redeem processing...",
  notifyMeWhenCompleted: "Notify me when completed",
  expectedTime: "Expected time:",
  redeemSeconds: "{count} seconds",
  redeemLoading: "loading...",
  estimatedCharge: "Estimated charge: {count} credits",

  estimatedCost: "Estimated cost: {count} credits",
  finalChargeBasedOnRequest:
    "Final charge may vary based on the successful completion of the request",
  showLess: "Show less",
  exportLeadsToCSV: "Export Leads to CSV",
  exportComplete: "Export Complete!",
  exporting: "Exporting...",
  pleaseSelectTheFieldsThatNeedToBeExported:
    "Please select the fields that need to be exported",
  exportLeads:
    "You’re about to export {count} lead. This may take a few moments, depending on the size of your selection. | You’re about to export {count} leads. This may take a few moments, depending on the size of your selection.",
  dataFieldsToInclude: "Data Fields to Include",
  savedListRecords: "{count} Record | {count} Records",
  deleteList: "Delete list",
  actionCannotBeUndone:
    "Are you sure you want to delete this list? This action cannot be undone.",
  selectedContactsNumber: "{count} of selected contacts",
  btnSave: "Save",
  btnUnsave: "Unsave",
  specialties: "Specialties",
  upgradeNowToAccessMore: "Upgrade now to access even more!",
  selectCompanyNumber:
    "Select up {count} company with your current plan. | Select up {count} companies with your current plan.",
  selectPeopleNumber:
    "Select up {count} prospect with your current plan. | Select up {count} prospects with your current plan.",
  selectAll: "All",
  selectThisPage: "This page",
  selectCustomize: "Customize",
  pleaseSelectTheFilteringType: "Please select the filtering type",
  theQuantityCannotBeZero: "The quantity cannot be 0",
  filterSearch: "Filter search",
  view: "view",
  deleteSavedSearch: "Delete saved search",
  deleteThisSavedSearch:
    "Are you sure you want to delete this saved search? This action cannot be undone.",
  createASequenceToStartAutomatingYourOutreach:
    "Create a sequence to start automating your outreach and add items here when you're ready.",
  unsaveThemFromHere:
    "If any selected leads are already saved, you can unsave them from here.",
  createAListToSaveAndOrganizeProspects:
    "Create a list to save and organize your prospects",
  savedFilters: "Saved Filters",
  viewResults: "View Results",

  // search empty
  resultNoResultsFound: "No Results Found",
  noContactsThatMatchYourSearch:
    "No matches for your search or filters. Try <br />changing the filters or using different keywords.",
  requestTimedOut: "Request Timed Out",
  theServerIsCurrentlyBusy:
    "The server is currently busy, and we couldn’t load <br /> the results. Please try refreshing the page.",
  btnRefresh: "Refresh",

  // tooltip
  tooltipRedeemEmail: "Redeem email",
  tooltipRedeemPhone: "Redeem phone",
  tooltipRedeemEmailAndPhone: "Redeem all",
  tooltipSearchPeople: "Find people from selected companies",
  tooltipFilter: "Filter",
  tooltipSequence: "Sequence",
  tooltipSave: "Save",
  textFindPeople: "Find People",

  // recent mode
  recentMode: "Recent mode",
  tryRealTimeAgain: "Try real-time again",
  realTimeResultsAreTemporarilyPaused:
    "Real-time results are temporarily paused due to API limits",

  // company-detail
  companies: "Companies",

  // recent search
  popularUseCases: "POPULAR USE CASES",
  skipTheGuesswork: "Skip the guesswork — start with popular filter combos.",
  labelRecentSearches: "RECENT SEARCHES",
  labelRecentSavedFilters: "RECENT SAVED FILTERS",
  useThisFilterSetup: "Use this filter setup",
  startByApplyingFilters:
    "Start by applying filters from the left panel to discover relevant contacts and companies.",

  //
  k: "k",

  filterAdvertisementStartDateSubTitle: "Advertisement Start Date Period",
  filterAdvertisementEndDateSubTitle: "Advertisement End Date Period",
  filterAdvertisementSearchTermsSubTitle: "Advertisement Search Terms",
  filterAdvertisementExcludeTargetLocation: "Exclude Target Location",

  active_filters_count: "1 Active filter | {count} Active filters",
  company_list: "Company lists",
  filter_presets: "Filter presets",
  my_list: "My list",
  company_profile: "Company profile",
  people_workforce: "PEOPLE & WORKFORCE",
  technology_presence: "TECHNOLOGY AND PRESENCE",
  saved_searches_count: "{count} Saved",
  filterJobExcludeLocation: "Job Exclude Location",

  enter_keywords: "Enter keywords",
  filter_keywords_description_search_title: "Search within descriptions",
  filter_keywords_description_search_tooltip:
    "Search for keywords within company descriptions.",
  filter_places_description_search_title: "Exclude specific places",
  filter_places_description_search_tooltip:
    "Exclude specific places from your search results.",
  enter_places: "Enter places",
  enterAdvertisementSearchTerms: "Enter search terms and press the Enter key...",
  people_list: "People list",
  clear: "Clear",

  "places": "Places",

  expand_filters: "Open filters",
  collapse_filters: "Close filters",
};
